const prependTitle = 'ServiceQuery';

// eslint-disable-next-line
export const makeServiceQuery = (queryName: string, options: any) =>
    new Promise((resolve, reject) => {
        const uid = Symbol('uniqueSymbol');

        const makeQuery = () => {
            const event = new CustomEvent(`${prependTitle}.query.${queryName}`, {
                detail: { uid, options }
            });
            window.dispatchEvent(event);
        };

        const removeListeners = () => {
            // eslint-disable-next-line
            window.removeEventListener(`${prependTitle}.response.${queryName}`, listenForResponse);
            window.removeEventListener(`${prependTitle}.ready.${queryName}`, makeQuery);
        };

        const listenForResponse = ({ detail }: CustomEvent) => {
            if (detail.uid === uid) {
                resolve(detail.response);
                removeListeners();
            }
        };

        window.addEventListener(`${prependTitle}.response.${queryName}`, listenForResponse);
        window.addEventListener(`${prependTitle}.ready.${queryName}`, makeQuery);

        makeQuery();
    });
